import React, { Component } from "react";
import * as Constants from "../../../../constants/Constants";
const _ = require("lodash");

export default class StatusRenderer extends Component {
  render() {
    return (
      <div className="curStatus">
        {!_.isEmpty(this.props.value) &&
          Object.entries(this.props.value).map((value) => {
            return (
              <div key={value[0]}>
                {value[0] !== "statusCount" && (
                  <p
                    id={value[0]}
                    className={
                      value[1] === Constants.COMPLETED
                        ? "statusCompleted statusBox"
                        : value[1] === Constants.IN_PROGRESS
                        ? "statusInProcess statusBox"
                        : "statusNotStarted statusBox"
                    }
                    title={value[0]
                      .replace(/([A-Z]+)/g, " $1")
                      .toLocaleUpperCase()}
                  />
                )}
              </div>
            );
          })}
        {_.isEmpty(this.props.value) && (
          <div className="curStatus">
            <p
              id="companyDetailsEmpty"
              className="statusNotStarted statusBox"
              title={Constants.VERBIAGE_COMPANY_DETAILS}
            />
            <p
              id="preBoardEmpty"
              className="statusNotStarted statusBox"
              title={Constants.VERBIAGE_PRE_BOARDING}
            />
            <p
              id="integrationEmpty"
              className="statusNotStarted statusBox"
              title={Constants.VERBIAGE_INTEGRATION}
            />
            <p
              id="publishEmpty"
              className="statusNotStarted statusBox"
              title={Constants.VERBIAGE_PUBLISH}
            />
          </div>
        )}
        <p>{this.props.value && this.props.value["statusCount"]}</p>
      </div>
    );
  }
}
